import { toggleProgramSource } from '@shoflo/studio-redux/actions';
import deleteSource from './deleteSource';
import { setProgram } from 'actions/program';

function removePresenter(sourceValue) {
  return (dispatch, getState) => {
    const {
      broadcastSources,
      program: { layers = [] },
    } = getState();
    const [source] = broadcastSources.sources.filter(
      (bs) => bs.value === sourceValue
    );

    if (!source) {
      return;
    }

    const { _id: sourceId } = source;
    const [layerSource] = layers.filter(
      (layer) => layer.source._id === sourceId
    );

    // Remove if screen is in program
    if (!!layerSource) {
      dispatch(toggleProgramSource(source, setProgram));
    }
    dispatch(deleteSource(sourceId));
  };
}

export default removePresenter;
